import React from "react";
import { Link, useLocation } from "react-router-dom";

const Footer = () => {

  const location = useLocation();
  const isHome = location.pathname === '/';

  return (
    <footer className="relative bg-slate-900 text-white py-10 px-4 sm:px-6">
      <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8 sm:gap-10">
        <div>
          <div className="flex items-center space-x-3 mb-4">
            <img
              src="assets/img/favicon.png"
              alt="Logo"
              className="sm:w-[2.5rem]"
            />
            <div className="flex items-baseline space-x-1">
              <span className="text-xl sm:text-2xl font-bold text-white">
                Magma
              </span>
              <span className="text-xl sm:text-2xl font-bold text-violet-600">
                OPD
              </span>
            </div>
          </div>
          <p className="text-sm text-gray-300 max-w-xs leading-relaxed">
            Trusted healthcare solutions tailored for your well-being. 24/7 access
            to medical support and consultation.
          </p>
        </div>
        <div>
          <h4 className="text-base sm:text-lg font-semibold mb-3">Quick Links</h4>
          <ul className="space-y-2 text-sm">
            <li>
              <Link to="/" className="hover:text-violet-400 transition-colors">
                Home
              </Link>
            </li>
            <li>
              <Link to="/about-us" className="hover:text-violet-400 transition-colors">
                About Us
              </Link>
            </li>
            <li>
              <Link
                to="/magmapremiumcare"
                className="hover:text-violet-400 transition-colors"
              >
                Plans
              </Link>
            </li>
            <li>
              <Link
                to="/contact"
                className="hover:text-violet-400 transition-colors"
              >
                Contact
              </Link>
            </li>
          </ul>
        </div>
        <div>
          <h4 className="text-base sm:text-lg font-semibold mb-3">Our Services</h4>
          <ul className="space-y-2 text-sm text-slate-300">
            <li>
              <Link
                to="/privacy-policy"
                className="hover:text-violet-400 transition-colors"
              >
                Privacy Policy
              </Link>
            </li>
            <li>
              <Link to="/term-of-use" className="hover:text-violet-400 transition-colors">
                Terms &amp; Conditions
              </Link>
            </li>
            <li>
              <Link to="/cancellation-policy" className="hover:text-violet-400 transition-colors">
                Refund Policy
              </Link>
            </li>
            <li>
              <Link
                to="/shipping-delivery-policy"
                className="hover:text-violet-400 transition-colors"
              >
                E-Shipping &amp; Delivery Policy
              </Link>
            </li>
          </ul>
        </div>
        <div>
          <h4 className="text-base sm:text-lg font-semibold mb-3">Contact Us</h4>
          <div className="space-y-3 text-sm leading-relaxed">
            {/* <div className="flex items-start gap-2">
              <svg
                stroke="currentColor"
                fill="currentColor"
                strokeWidth={0}
                viewBox="0 0 384 512"
                className="text-violet-400 mt-1"
                height="1em"
                width="1em"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"></path>
              </svg>
              <span>Basement, 5B-16, Tilak Nagar, New Delhi 110018</span>
            </div> */}
            <div className="flex items-center gap-2">
              <svg
                stroke="currentColor"
                fill="currentColor"
                strokeWidth={0}
                viewBox="0 0 512 512"
                className="text-violet-400"
                height="1em"
                width="1em"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M424 80H88a56.06 56.06 0 0 0-56 56v240a56.06 56.06 0 0 0 56 56h336a56.06 56.06 0 0 0 56-56V136a56.06 56.06 0 0 0-56-56zm-14.18 92.63-144 112a16 16 0 0 1-19.64 0l-144-112a16 16 0 1 1 19.64-25.26L256 251.73l134.18-104.36a16 16 0 0 1 19.64 25.26z"></path>
              </svg>
              <a
                href="mailto:support@magmaopd.in"
                className="hover:text-violet-400"
              >
                support@magmaopd.in
              </a>
            </div>
            <div className="flex items-center gap-2">
              <svg
                stroke="currentColor"
                fill="currentColor"
                strokeWidth={0}
                viewBox="0 0 512 512"
                className="text-violet-400"
                height="1em"
                width="1em"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M164.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C12.1 30.2 0 46 0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L304.7 368C234.3 334.7 177.3 277.7 144 207.3L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96z"></path>
              </svg>
              <a href="tel:9899761818" className="hover:text-violet-400">
                9899761818
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="w-full h-[1px] mt-10 mb-6 bg-gray-600" />
      <div className="w-full max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-gray-400">
        <p className="text-center sm:text-right w-full sm:w-auto">
          © 2025{" "}
          <Link
            to="/about-us"
            className="text-white hover:text-violet-400 underline transition-colors"
          >
            Magma OPD
          </Link>
          . All rights reserved.
        </p>
        
      </div>
    </footer>

  );
};

export default Footer;
